module.exports = __webpack_public_path__ + "img/img1.de98ac6f.png";